// 메뉴 관리 탭 리스트
export const TAB_LIST = [
  { title: '메뉴 관리', value: 'menu' },
  { title: '옵션 관리', value: 'option' },
  { title: '메뉴 순서', value: 'order' },
  { title: '추천 메뉴', value: 'recommend' },
  { title: '원산지 정보', value: 'origin' },
];
